__turbopack_context__.v({
  "bannerImage": "lD0Ucq_bannerImage",
  "brutaleApp": "lD0Ucq_brutaleApp",
  "container": "lD0Ucq_container",
  "dangerText": "lD0Ucq_dangerText",
  "deliveryInfoText": "lD0Ucq_deliveryInfoText",
  "deliveryStatusRow": "lD0Ucq_deliveryStatusRow",
  "detailsBottomRow": "lD0Ucq_detailsBottomRow",
  "detailsContainer": "lD0Ucq_detailsContainer",
  "headerWrapper": "lD0Ucq_headerWrapper",
  "imgContainer": "lD0Ucq_imgContainer",
  "logoImage": "lD0Ucq_logoImage",
  "marginBottom": "lD0Ucq_marginBottom",
  "orderFormats": "lD0Ucq_orderFormats",
  "outletActionsContainer": "lD0Ucq_outletActionsContainer",
  "outletAddress": "lD0Ucq_outletAddress",
  "outletStateInfo": "lD0Ucq_outletStateInfo",
  "rightActions": "lD0Ucq_rightActions",
  "successText": "lD0Ucq_successText",
  "whiteLabeled": "lD0Ucq_whiteLabeled",
});
